import React from 'react'
import { connect } from 'react-redux'
import {
  Field, formValueSelector, reduxForm, change as changeFieldValue,
} from 'redux-form';
import Pessoa from './Pessoa';
import { apenasNumero, renderFieldCpfCnpj, validarCpfCnpj } from '../../util/inputs';
import ModalCadastroPessoa from './ModalCadastroPessoa';
import selecionarEnderecoRemetente from '../../actions/endereco/selecionarEnderecoRemetente';
import buscarPessoaRemetentePorCpfCnpj from '../../actions/pessoa/buscarPessoaRemetentePorCpfCnpj';
import selecionarPessoaRemetente from '../../actions/pessoa/selecionarPessoaRemetente';
import recuperarPessoaPorCpfCnpj from '../../actions/pessoa/recuperarPessoaPorCpfCnpj';

const selector = formValueSelector('formularioCadastroEncomenda');


export class AbaRemetente extends React.Component {
  limparFormularioPessoa () {
    this.props.changeFieldValue('formularioCadastroPessoa',
      'nome', '');
    this.props.changeFieldValue('formularioCadastroPessoa',
      'cpfCnpj', this.props.cpfCnpjRemetente);
    this.props.changeFieldValue('formularioCadastroPessoa',
      'email', '');
    this.props.changeFieldValue('formularioCadastroPessoa',
      'telefone', '');
  }

  exibirPessoa () {
    if (this.props.pessoaRemetente && this.props.pessoaRemetente.id) {
      return <Pessoa pessoa={this.props.pessoaRemetente}
                     selecionarEnderecoRemetenteDestinatario={this.props.selecionarEnderecoRemetente}
                     enderecoSelecionado={this.props.enderecoRemetente}
                     buscarPessoa={this.props.buscarPessoaRemetentePorCpfCnpj}
                     changeFieldValue={this.props.changeFieldValue}/>;
    }
    if (!this.props.pessoaRemetente) {
      return (
        <div className="alert alert-warning mt-4 text-center" role="alert">
          <div className='col-md-12'>Nenhuma pessoa encontrada para o CPF/CNPJ: {this.props.cpfCnpjRemetente}</div>
          <a data-toggle="modal" data-target="#modalCadastrarPessoa" className='col-md-12' style={{ color: '#0789dd' }}
             onClick={() => { this.limparFormularioPessoa(); this.buscarUsuarioPorCpf() }}>Clique aqui para cadastrar.</a>
        </div>

      )
    }
  }

  buscarUsuarioPorCpf () {
    this.props.recuperarPessoaPorCpfCnpj(apenasNumero(this.props.cpfCnpjRemetente)).then((resp) => {
      if (resp.payload.data !== '' && resp.payload.status === 200) {
        this.props.changeFieldValue('formularioCadastroPessoa', 'nome', resp.payload.data.nome);
      } else {
        this.props.changeFieldValue('formularioCadastroPessoa', 'nome', '');
      }
    })
  }

  zerar (e) {
    this.props.selecionarEnderecoRemetente(null);
    if (!this.props.cpfCnpjRemetente || e.target.value.trim().length < this.props.cpfCnpjRemetente.trim().length) {
      this.props.selecionarPessoaRemetente({});
    }
  }

  render () {
    return (
      <div className="vx-enc-flow">
        <div className="vx-search-card">
          <div className="vx-enc-section-header">
            <div className="vx-enc-section-title">
              <i className="material-icons">badge</i>
              Identificação do Remetente
            </div>
          </div>
          <div className="vx-enc-search-row">
            <div style={{ flex: '1 1 260px', maxWidth: 340 }}>
              <Field name='cpfCnpjRemetente' type="text" component={renderFieldCpfCnpj} label="CPF / CNPJ"
                validate={[validarCpfCnpj]}
                css="form-control" readOnly={false} onChange={e => this.zerar(e)}/>
            </div>
            <button className="vx-btn-buscar" style={{ width: 'auto', flexShrink: 0 }}
              onClick={() => this.props.buscarPessoaRemetentePorCpfCnpj(this.props.cpfCnpjRemetente)}
              disabled={apenasNumero(this.props.cpfCnpjRemetente).length !== 11 && apenasNumero(this.props.cpfCnpjRemetente).length !== 14}>
              <i className="material-icons">search</i>
              Buscar
            </button>
          </div>
        </div>
        {this.exibirPessoa()}
        <ModalCadastroPessoa buscarPessoa={this.props.buscarPessoaRemetentePorCpfCnpj}/>
      </div>
    )
  }
}


export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada,
    cpfCnpjRemetente: selector(state, 'cpfCnpjRemetente'),
    enderecoRemetente: state.enderecoRemetente,
    pessoaRemetente: state.pessoaRemetente,
    initialValues: {
      cpfCnpjRemetente: state.pessoaRemetente.cpfCnpj
    }
  });


export default connect(mapStateToProps, {
  selecionarEnderecoRemetente,
  recuperarPessoaPorCpfCnpj,
  buscarPessoaRemetentePorCpfCnpj,
  selecionarPessoaRemetente,
  changeFieldValue
})(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaRemetente))
